<template>
  <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 14 }, }"
    ref="ruleForm">
    <a-form-model-item label="量表官方网站/文献网址">
      <a-input placeholder="量表官方网站/文献网址" v-model="model.web" />
    </a-form-model-item>
    <a-form-model-item label="量表英文文献PMID">
      <a-input placeholder="量表英文文献PMID" v-model="model.pmid" />
    </a-form-model-item>
    <a-form-model-item label="量表英文文献DOI">
      <a-input placeholder="量表英文文献DOI" v-model="model.doi" />
    </a-form-model-item>
    <a-form-model-item label="汉化版文献下载地址">
      <a-input placeholder="汉化版文献下载地址" v-model="model.downAddress" />
    </a-form-model-item>
    <a-form-model-item label="量表官方使用说明网址">
      <a-input placeholder="量表官方使用说明网址" v-model="model.webDes" />
    </a-form-model-item>
    <a-form-model-item label="量表官方使用说明文献号">
      <a-input placeholder="量表官方使用说明文献号" v-model="model.webNum" />
    </a-form-model-item>
    <a-form-model-item label="量表附件(上传)">
      <j-upload v-model="modelFileList.fileList" :bizPath="bizPath" multiple :delfile="deleteFile">
        <a-button icon="upload" size="small">点击上传</a-button>
      </j-upload>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import JUpload from "@comp/jeecg/JUpload"
import { deleteAction } from '@/api/manage'
export default {
  name: "FormAnnexModal",
  components: { JUpload },
  props: ['model', 'modelFileList','formid'],
  data() {
    return {
      title: "操作",
      visible: true,
      bizPath: 'form',
    }
  },
  created() {    
    this.bizPath += '/' + this.formid
  },
  methods: {
    deleteFile(id){
      if(!id){
        return
      }
      deleteAction('/tempconfig/tempConfigFormFile/delete', { id: id }).then(res => {
          if (res.success) {
            console.log('OK')            
          }else{
            this.$message.warn(res.message)
          }
          this.$emit('unloadFile')
        })
    }    
  }
}
</script>

<style lang="less" scoped></style>